export const regex = {
  phoneNumber: /^[2-9]\d{9}$/,
  name: /^[A-Za-z ]*$/,
  email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/, //https://www.w3resource.com/javascript/form/email-validation.php
};
